var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",style:([_vm.page_style])},[_c('button',{staticClass:"btn",style:([_vm.btn_style]),on:{"click":_vm.next}}),_c('page-wrap',{attrs:{"title":_vm.page_title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }